import {
  faInstagram,
  faLinkedin,
  faMediumM,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { graphql, Link, useStaticQuery } from 'gatsby';
import React from 'react';
import '../styles/global.scss';

const Footer = () => {
  const data = useStaticQuery(
    graphql`
      query {
        contentfulFooterQuickLinksJsonNode {
          Headings
          Urls
        }
        contentfulFooterExploreJsonNode {
          Headings
          Urls
        }
        contentfulFooter {
          altTextBelowLogo
          footerLogo {
            file {
              url
            }
          }
        }
      }
    `
  );
  return (
    <div className='wrapper' style={{ maxWidth: '100vw' }}>
      <footer className='footer'>
        <div
          className='columns is-full is-hidden-desktop is-hidden-tablet'
          style={{
            paddingLeft: '10px',
          }}
        >
          <Link
            activeClassName='active'
            className='link-footer'
            to='/'
            style={{ color: '#ffffff' }}
          >
            <img
              src={data.contentfulFooter.footerLogo.file.url}
              alt='Footer Logo'
              style={{ paddingBottom: '10px', paddingLeft: 10 }}
              className='is-hidden-desktop is-hidden-tablet'
              loading='lazy'
            />
          </Link>
          <div
            className='column is-size-5 is-hidden-desktop is-hidden-tablet'
            style={{
              verticalAlign: 'left',
              justifyContent: 'left',
            }}
          >
            {' '}
            <ul>
              <li>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  to={data.contentfulFooterQuickLinksJsonNode.Urls[0]}
                >
                  <span className='is-size-6-mobile '>
                    {data.contentfulFooterQuickLinksJsonNode.Headings[0]}
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  to={data.contentfulFooterQuickLinksJsonNode.Urls[1]}
                >
                  <span className='is-size-6-mobile'>
                    {data.contentfulFooterQuickLinksJsonNode.Headings[1]}
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  to={data.contentfulFooterQuickLinksJsonNode.Urls[2]}
                >
                  <span className='is-size-6-mobile'>
                    {data.contentfulFooterQuickLinksJsonNode.Headings[2]}
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  to='/resources'
                >
                  <span className='is-size-6-mobile'>
                    {data.contentfulFooterQuickLinksJsonNode.Headings[3]}
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  to='/ContactUs'
                >
                  <span className='is-size-6-mobile'>
                    {data.contentfulFooterQuickLinksJsonNode.Headings[4]}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className='columns'>
          <div
            className='column is-two-thirds footer-left-container'
            style={{ display: 'grid' }}
          >
            <Link
              activeClassName='active'
              className='link-footer'
              to='/'
              style={{ color: '#ffffff' }}
            >
              <img
                src={data.contentfulFooter.footerLogo.file.url}
                alt='Footer Logo'
                className='is-hidden-mobile'
                style={{ paddingLeft: '10vw', paddingTop: '12px' }}
                loading='lazy'
              />
            </Link>
            <div className='links-footer-misc'>
              <Link
                target='_blank'
                to='/about/#address'
                className='privacy-policy is-hidden-mobile'
                style={{ transition: '0.4s ease', paddingLeft: '10vw' }}
              >
                Office Locations
              </Link>
              <span
                className='is-hidden-mobile'
                style={{
                  color: '#fff',
                  padding: '0 5px 0 0',
                }}
              >
                {' '}
                |
              </span>
              <Link
                target='_blank'
                to='/terms-and-condition'
                className='terms-conditions is-hidden-mobile'
                style={{ transition: '0.4s ease', paddingLeft: '0px' }}
              >
                Terms & Conditions
              </Link>
              <span
                className='is-hidden-mobile'
                style={{ color: '#fff', padding: '0 5px 0 5px' }}
              >
                {' '}
                |
              </span>
              <Link
                target='_blank'
                to='/privacy-policy'
                className='privacy-policy is-hidden-mobile'
                style={{ transition: '0.4s ease' }}
              >
                Privacy Policy
              </Link>
            </div>
            <div className=' is-hidden-mobile footer-copy'>
              © {new Date().getFullYear()}{' '}
              {data.contentfulFooter.altTextBelowLogo}
            </div>
          </div>
          <div className='column is-hidden-mobile'>
            <ul>
              <li className='foot-head' style={{ marginBottom: '5px' }}>
                QUICK LINKS
              </li>
              <li className='footer-urls-explore'>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  to='/product'
                  target='_blank'
                  style={{ font: 'Muli', transition: '0.4s ease' }}
                >
                  {data.contentfulFooterQuickLinksJsonNode.Headings[0]}
                </Link>
              </li>
              <li className='footer-urls-explore'>
                {' '}
                <Link
                  activeClassName='active'
                  className='link-footer'
                  to={data.contentfulFooterQuickLinksJsonNode.Urls[1]}
                  style={{ font: 'Muli', transition: '0.4s ease' }}
                >
                  {data.contentfulFooterQuickLinksJsonNode.Headings[1]}
                </Link>
              </li>
              <li className='footer-urls-explore'>
                {' '}
                <Link
                  activeClassName='active'
                  className='link-footer'
                  to={data.contentfulFooterQuickLinksJsonNode.Urls[2]}
                  style={{ transition: '0.4s ease' }}
                >
                  {data.contentfulFooterQuickLinksJsonNode.Headings[2]}
                </Link>
              </li>
              <li className='footer-urls-explore'>
                {' '}
                <Link
                  activeClassName='active'
                  className='link-footer'
                  style={{ transition: '0.4s ease' }}
                  to={data.contentfulFooterQuickLinksJsonNode.Urls[3]}
                >
                  {data.contentfulFooterQuickLinksJsonNode.Headings[3]}
                </Link>
              </li>
              <li className='footer-urls-explore'>
                {' '}
                <Link
                  activeClassName='active'
                  className='link-footer'
                  style={{ transition: '0.4s ease' }}
                  to='/ContactUs'
                >
                  {data.contentfulFooterQuickLinksJsonNode.Headings[4]}
                </Link>
              </li>
            </ul>
          </div>
          <div className='column is-hidden-mobile' style={{ color: '#ffffff' }}>
            <ul>
              <li
                className='foot-head'
                style={{ paddingBottom: '1rem', fontWeight: 'bold' }}
              >
                EXPLORE
              </li>
              <li className='footer-urls-explore'>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  target='__blank'
                  to={data.contentfulFooterExploreJsonNode.Urls[0]}
                >
                  <FontAwesomeIcon
                    icon={faMediumM}
                    style={{ width: 16, height: 16, transition: '0.4s ease' }}
                  />
                  <span style={{ marginLeft: '11px', transition: '0.4s ease' }}>
                    {data.contentfulFooterExploreJsonNode.Headings[0]}
                  </span>
                </Link>
              </li>
              <li className='footer-urls-explore'>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  target='__blank'
                  to={data.contentfulFooterExploreJsonNode.Urls[1]}
                  style={{ width: 16, height: 16 }}
                >
                  <FontAwesomeIcon icon={faTwitter} />
                  <span style={{ marginLeft: '11px', transition: '0.4s ease' }}>
                    {data.contentfulFooterExploreJsonNode.Headings[1]}
                  </span>
                </Link>
              </li>
              <li className='footer-urls-explore'>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  target='__blank'
                  to={data.contentfulFooterExploreJsonNode.Urls[2]}
                >
                  <FontAwesomeIcon
                    icon={faInstagram}
                    style={{ width: 16, height: 16, transition: '0.4s ease' }}
                  />
                  <span style={{ marginLeft: '11px', transition: '0.4s ease' }}>
                    {data.contentfulFooterExploreJsonNode.Headings[2]}
                  </span>
                </Link>
              </li>
              <li className='footer-urls-explore'>
                <Link
                  activeClassName='active'
                  className='link-footer'
                  target='__blank'
                  to={data.contentfulFooterExploreJsonNode.Urls[4]}
                >
                  <FontAwesomeIcon
                    icon={faLinkedin}
                    style={{ width: 16, height: 16, transition: '0.4s ease' }}
                  />
                  <span style={{ marginLeft: '11px', transition: '0.4s ease' }}>
                    {data.contentfulFooterExploreJsonNode.Headings[4]}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <center>
          <div className='columns is-mobile is-center is-hidden-desktop is-hidden-tablet'>
            <div className='column'>
              <Link
                activeClassName='active'
                className='link-footer'
                target='__blank'
                to={data.contentfulFooterExploreJsonNode.Urls[0]}
              >
                <FontAwesomeIcon icon={faMediumM} />
              </Link>
            </div>{' '}
            <div className='column'>
              <Link
                activeClassName='active'
                className='link-footer'
                target='__blank'
                to={data.contentfulFooterExploreJsonNode.Urls[4]}
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </Link>
            </div>{' '}
            <div className='column'>
              <Link
                activeClassName='active'
                className='link-footer'
                target='__blank'
                to={data.contentfulFooterExploreJsonNode.Urls[1]}
              >
                <FontAwesomeIcon icon={faTwitter} />
              </Link>
            </div>{' '}
            <div className='column'>
              <Link
                activeClassName='active'
                className='link-footer'
                target='__blank'
                to={data.contentfulFooterExploreJsonNode.Urls[2]}
              >
                <FontAwesomeIcon icon={faInstagram} />
              </Link>
            </div>{' '}
          </div>
        </center>
        <div
          className=' is-hidden-desktop is-hidden-tablet'
          style={{
            marginTop: '1.5rem',
            verticalAlign: 'center',
            textAlign: 'left',
            color: '#fff',
            fontSize: '11px',
            transition: '0.4s ease',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {' '}
          <center>
            © {new Date().getFullYear()}{' '}
            {data.contentfulFooter.altTextBelowLogo} <br />
            <Link
              target='_blank'
              to='/about/#address'
              style={{
                fontSize: '10px',
                padding: '5 0 0 0',
                transition: '0.4s ease',
              }}
              className='terms-conditions is-hidden-desktop is-hidden-tablet'
            >
              Office Locations
            </Link>
            <span
              className='is-hidden-desktop'
              style={{
                color: '#fff',
                padding: '0 5px 0 5px',
                transition: '0.4s ease',
              }}
            >
              |
            </span>
            <Link
              target='_blank'
              to='/terms-and-condition'
              style={{
                fontSize: '10px',
                padding: '5 0 0 0',
                transition: '0.4s ease',
              }}
              className='terms-conditions is-hidden-desktop is-hidden-tablet'
            >
              Terms & Conditions
            </Link>
            <span
              className='is-hidden-desktop'
              style={{
                color: '#fff',
                padding: '0 5px 0 5px',
                transition: '0.4s ease',
              }}
            >
              |
            </span>
            <Link
              target='_blank'
              to='/privacy-policy'
              style={{
                fontSize: '10px',
                padding: '5 0 0 0',
                transition: '0.4s ease',
              }}
              className='terms-conditions is-hidden-desktop is-hidden-tablet'
            >
              Privacy Policy
            </Link>
          </center>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
